jQuery( '.staggered-section .staggered-slider' ).slick( {
    dots: false,
    infinite: false,
    speed: 600,
    cssEase: 'ease',
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    autoplay: true,
    autoplaySpeed: 15000,
} );